module.exports = __webpack_public_path__ + "media/Guru.0e179dc9.mp3";